import {useRouter} from "next/router";
import React from "react";
import {openFileSelector} from "../../../helpers/file_picker";
import {isSafari} from "react-device-detect";
import RouteNames from "../../../Routes/RouteNames";
import {logFirebaseEvent} from "../../../helpers/firebase_helper";

interface IProps {
    className?: string;
    text: string;
    shouldSelectPhotos?: boolean;
    onClick?: () => void;
}

const PrimaryButton = ({
                           className,
                           text,
                           shouldSelectPhotos = true,
                           onClick,
                       }: IProps) => {
    const router = useRouter();


    async function handleFilePick(): Promise<boolean> {


        if (shouldSelectPhotos == true) {
            var files: string[] = await openFileSelector({
                accept: [".jpg", ".png", ".jpeg", ".gif", ".webp"],
            });
            // console.log(files.length);
            (window as any).state = {
                selectedFiles: files,
            };

            var iframe = document.getElementById("cm_iframe") as any;
            if (iframe != null) {
                iframe.contentWindow.postMessage({fileLoaded: true}, "*");
            }

            return files.length != 0;
        }
        return true

    }

    const onClickButton = async () => {
        if (isSafari) {
            const res = await handleFilePick();
            console.log("handleFilePick " + res);
            void router.push(RouteNames.collageEditor);

            if (res) {
                logFirebaseEvent("cus_select_photos", {
                    location: "web_home",
                });
            }
        } else {
            void router.push(RouteNames.collageEditor);
            const res = await handleFilePick();
            console.log("handleFilePick " + res);
            if (res) {
                logFirebaseEvent("cus_select_photos", {
                    location: "web_home",
                });
            }
        }
    }

    return (
        <button
            className={`${className} bg-yellow px-6 py-4 text-white tracking-wide`}
            onClick={onClick ?? onClickButton}
        >
            {text}
        </button>
    );
};

export default PrimaryButton;
